import React from 'react';
import { Twitter, Send, Globe, Mail } from 'lucide-react';
import LayerSeekLogo from './LayerSeekLogo';

const Footer = () => {
  const footerLinks = {
    event: [
      { label: 'About', href: '#about' },
      { label: 'Schedule', href: '#schedule' },
      { label: 'Speakers', href: '#speakers' },
      { label: 'Sponsors', href: '#sponsors' }
    ],
    tickets: [
      { label: 'Individual Tickets', href: '#pricing' },
      { label: 'Team Packages', href: '#pricing' },
      { label: 'Sponsorship', href: '#pricing' },
      { label: 'Group Discounts', href: '#pricing' }
    ],
    resources: [
      { label: 'FAQ', href: '#faq' },
      { label: 'Contact Us', href: 'mailto:hi@zedit.io' },
      { label: 'Refund Policy', href: '/layerseek/refunds' },
      { label: 'Terms of Service', href: '/layerseek/terms' }
    ]
  };

  const socialLinks = [
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Send, href: '#', label: 'Telegram' },
    { icon: Globe, href: '#', label: 'Website' }
  ];

  return (
    <footer className="bg-[var(--bg-secondary)] border-t border-[var(--border-subtle)]">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-16">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="mb-4" data-testid="footer-logo">
              <LayerSeekLogo size="default" />
            </div>
            <p className="text-sm text-[var(--text-muted)] mb-6">
              The premier virtual summit for DeFi protocol collaboration.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 rounded-lg bg-[var(--bg-tertiary)] flex items-center justify-center text-[var(--text-muted)] hover:bg-[var(--accent-primary)] hover:text-[var(--bg-primary)] transition-all hover:-translate-y-0.5"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
          
          {/* Links */}
          <div>
            <h4 className="font-semibold mb-4">Event</h4>
            <ul className="space-y-3">
              {footerLinks.event.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm text-[var(--text-muted)] hover:text-[var(--accent-primary)] transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Tickets</h4>
            <ul className="space-y-3">
              {footerLinks.tickets.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm text-[var(--text-muted)] hover:text-[var(--accent-primary)] transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm text-[var(--text-muted)] hover:text-[var(--accent-primary)] transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        {/* Newsletter */}
        <div className="mt-12 pt-8 border-t border-[var(--border-subtle)]">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <h4 className="font-semibold mb-1">Stay Updated</h4>
              <p className="text-sm text-[var(--text-muted)]">Get the latest updates about LayerSeek DeFi Protocol Summit.</p>
            </div>
            <div className="flex gap-2">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="px-4 py-3 rounded-xl bg-[var(--bg-tertiary)] border border-[var(--border-primary)] text-sm text-white placeholder:text-[var(--text-muted)] focus:outline-none focus:border-[var(--accent-primary)] w-64"
              />
              <button className="px-6 py-3 rounded-xl bg-[var(--accent-primary)] text-[var(--bg-primary)] font-semibold hover:bg-[var(--accent-hover)] transition-colors">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        
        {/* Disclaimer */}
        <div className="mt-12 pt-8 border-t border-[var(--border-subtle)]">
          <p className="text-xs text-[var(--text-muted)] text-center max-w-4xl mx-auto">
            LayerSeek is an educational and networking event. It does not provide financial, investment, or legal advice. Attendees are responsible for their own decisions. Speakers and sponsors participate independently and their views do not represent the organizers.
          </p>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 text-center">
          <p className="text-sm text-[var(--text-muted)]">
            © 2026 LayerSeek by Zedit Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;